(ns common.filter-controls
  (:require
   [camel-snake-kebab.core :as csk]
   [common.css             :as css]
   [tailwind-hiccup.core   :refer [tw]]))

(def ^:private field ^:tw [:block])

(def ^:private field-title ^:tw [:font-bold])

(defn title-key
  "The translation key for `filter-key`'s title."
  [filter-key]
  [:backend.views.public/filter-title filter-key])

(defn option-label-key
  "The translation key for `option`'s label under `filter-key`."
  [filter-key option]
  [:backend.views.public/filter-option filter-key option])

(defn param-key
  "The query param `filter-key`'s selection travels under, which is also the
   param the map tiles and the marker count are filtered by."
  [filter-key]
  (csk/->snake_case_keyword filter-key))

(defn filters->params
  "`filters`, a map of filter key to selected option, as query params."
  [filters]
  (update-keys filters param-key))

(defn params->selection
  "The option `params` select for `filter-key`, or nil when they name none of
   `options`."
  [params filter-key options]
  (some #{(get params (param-key filter-key))} options))

(defn params->selections
  "Returns a map with the filter selections for which the query param is non-nil"
  [params filter-key->options]
  (into {}
        (keep (fn [[filter-key options]]
                (when-let [selection (params->selection params filter-key options)]
                  [filter-key selection])))
        filter-key->options))

(defn Dropdown
  "One filter: a title above a dropdown of `options`, each a map of the
   `:value` an option submits, the `:label` it shows, and whether it is the
   `:selected?` one."
  [{:keys [active? options select-props title]}]
  [:label (tw field)
   [:div (tw field-title (when active? ^:tw [:text-blue-0])) title]
   (into [:select (tw (if active? css/select-active css/select) select-props)]
         (for [{:keys [label selected? value]} options]
           ^{:key value} [:option (cond-> {:value value}
                                    selected? (assoc :selected true))
                          label]))])
